/** Parse storage tier from listing title, e.g. "iPhone 17 Pro Max 256GB 2025". */
export function parseStorageGbFromTitle(title: string | null | undefined): number | null {
  if (!title) return null
  const match = title.match(/\b(\d{2,4})\s*GB\b/i)
  if (!match) return null
  const gb = Number.parseInt(match[1], 10)
  return Number.isFinite(gb) ? gb : null
}

export type LiveMarketListingInput = {
  title: string
  condition: string
  battery_health?: number | null
  release_year?: number | null
  in_box_completeness?: string | null
  phone_model_id?: number | null
  phone_model?: { id?: number; release_year?: number | null } | null
}

export function liveMarketSuggestBody(listing: LiveMarketListingInput) {
  const phoneModelId = listing.phone_model_id ?? listing.phone_model?.id
  if (!phoneModelId) return null
  const storageGb = parseStorageGbFromTitle(listing.title)
  return {
    phone_model_id: phoneModelId,
    condition: listing.condition,
    battery_health: listing.battery_health ?? undefined,
    release_year:
      listing.release_year ?? listing.phone_model?.release_year ?? undefined,
    storage_gb: storageGb ?? undefined,
    in_box_completeness: (listing.in_box_completeness ?? undefined) as
      | 'full'
      | 'partial'
      | 'phone_only'
      | undefined,
  }
}
